<template>
  <div
    class="app-icon"
    :style="{
        width: width + 'px', 
        height: height + 'px'
    }"
    @mouseover="hovering=true"
    @mouseout="hovering=false"
  >
    <component
      v-bind:is="name"
      :width="width"
      :height="height"
      :color="(hovering && hoverColor) ? hoverColor : color"
      :detailsOpacity="detailsOpacity"
      :active="active"
    ></component>
  </div>
</template>
<script>
    const libIcons = [
        'avatar',
        'bar-code',
        'camera',
        'cash-check',
        'chat',
        'check',
        'checkbox-delete-square',
        'checkbox-remove-square',
        'contact-less',
        'contact-location',
        'contact-phone',
        'count-down',
        'coupon',
        'credit-card',
        'dashboard',
        'delete',
        'discount',
        'double-check',
        'email-draft',
        'emoji',
        'fingerprint',
        'flag',
        'hide-eye',
        'historic',
        'mic',
        'minus-square',
        'pencil',
        'plus',
        'price-high-to-low',
        'printer',
        'product-box',
        'receipt',
        'reply-all',
        'search',
        'security',
        'send',
        'service-box',
        'show-eye',
        'solution-tips',
        'settings',
        'radio-button-selected',
        'radio-button-unselected',
        'timer',
        'warning',
        'whatsapp',
        'zepplin-report',
        'zepplin'
    ]
    export default {
        data(){
            return {
                hovering: null
            }
        },
        components: (function(){
            let icons = {}
            _.forEach(libIcons,(libIcon) => {
                icons[libIcon] = () => {
                    return import(`./icons/${libIcon}.vue`)
                }
            })
            return icons
        })(),
        props:{
            name: {
                type: String,
                default: "product-box"
            },
            width: {
                default: 16
            },
            height: {
                default: 16
            },
            color: {
                type: String,
                default: "#55595E"
            },
            hoverColor: {
                type: String,
                default: null
            },
            detailsOpacity: {
                default: 0.5
            },
            active: {
                required: false,
                default: false,
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
.app-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>